<script lang="ts">
	export let disabled = false;
	export let type: 'button' | 'submit' | 'reset' = 'button';
	export let color = '';
</script>

<button on:click {disabled} {type} style={`color: ${color}`}>
	<slot />
</button>

<style>
	button {
		border: none;
		background-color: transparent;
		color: var(--BLUE);
		cursor: pointer;
	}

	button:hover {
		text-decoration: underline;
	}

	:disabled {
		color: var(--grayLight);
		pointer-events: none;
	}
</style>
